module.exports = __webpack_public_path__ + "img/Logo copy.2143742b.png";